import { Typography, Stack } from '@mui/material';
import type { AzureRestorePointDataRestorePointTypeEnum } from '@repo/api-gw-sdk';
import classNames from 'classnames';

import { Tag } from '@/components/tag';
import { formatRestorePointType } from '@/utils/azure';
import { dayjs, TIME_FORMAT } from '@/utils/dayjs';

import { OtherSnapshotDot } from '../otherSnapshotDot';

export const ConvertSnapshotsSummary = ({
  isMultiTimes,
  time,
  numOfVols,
  restorePointType,
  volLabel,
  customLabel,
}: {
  isMultiTimes: boolean;
  time: string | Date;
  numOfVols?: number;
  restorePointType?: AzureRestorePointDataRestorePointTypeEnum;
  volLabel?: string;
  customLabel?: string;
}) => {
  return (
    <Stack
      gap='80px'
      direction='row'
      alignItems='center'
      className={classNames('flex-1', {
        'cursor-pointer': isMultiTimes,
      })}
    >
      <Stack width='132px' direction='row' gap='12px' alignItems='center'>
        <OtherSnapshotDot />
        <Typography>{dayjs.utc(time).format(TIME_FORMAT)} UTC</Typography>
      </Stack>
      {numOfVols !== undefined && numOfVols > 0 && volLabel && (
        <Typography variant='body1'>
          {numOfVols} {numOfVols > 1 ? `${volLabel}s` : volLabel}
        </Typography>
      )}
      {customLabel && <Typography variant='body1'>{customLabel}</Typography>}
      {restorePointType && (
        <Tag
          content={formatRestorePointType(restorePointType)}
          variant='secondary'
        />
      )}
    </Stack>
  );
};
